import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useAtom } from 'jotai';
import React from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import CloseIcon from '@/assets/icon/close.svg';
import { searchHistoriesAtom } from '@/atoms/User';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function SearchHistories({ onPressHistory: onClickSearch, }) {
    const [searchHistories, setSearchHistories] = useAtom(searchHistoriesAtom);
    if (searchHistories === null || searchHistories.length === 0) {
        return null;
    }
    return (_jsxs(Container, { children: [_jsxs(TitleWrap, { children: [_jsx(TitleText, { children: "\uCD5C\uADFC \uAC80\uC0C9\uC5B4" }), _jsx(SccTouchableOpacity, { elementName: "clear_all_search_histories", onPress: () => setSearchHistories([]), children: _jsx(ClearAllText, { children: "\uBAA8\uB450 \uC0AD\uC81C" }) })] }), _jsx(ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, style: { overflow: 'visible' }, contentContainerStyle: {
                    flexDirection: 'row',
                    gap: 6,
                    flexWrap: 'nowrap',
                }, children: searchHistories.map(search => (_jsxs(ItemBox, { children: [_jsx(SccTouchableOpacity, { elementName: "recent_keyword", logParams: { keyword: search }, onPress: () => onClickSearch(search), children: _jsx(ItemText, { numberOfLines: 1, children: search }) }), _jsx(RemoveButton, { elementName: "recent_keyword_remove_button", logParams: { keyword: search }, onPress: () => {
                                var _a;
                                setSearchHistories((_a = searchHistories.filter(s => s !== search)) !== null && _a !== void 0 ? _a : []);
                            }, children: _jsx(CloseIcon, { color: color.gray80, width: 9, height: 9 }) })] }, search))) })] }));
}
const Container = styled.View `
  gap: 12px;
`;
const TitleWrap = styled.View `
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const TitleText = styled.Text `
  font-size: 14px;
  font-family: ${() => font.pretendardBold};
  color: ${() => color.black};
`;
const ClearAllText = styled.Text `
  font-size: 13px;
  font-family: ${() => font.pretendardRegular};
  color: ${() => color.gray70};
`;
const ItemBox = styled.View `
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-color: ${() => color.gray20};
  border-radius: 100px;
  padding-vertical: 7px;
  padding-left: 12px;
  padding-right: 8px;
  background-color: ${() => color.white};
  height: 36px;
`;
const ItemText = styled.Text `
  font-size: 15px;
  line-height: 22px;
  font-family: ${() => font.pretendardRegular};
  color: ${() => color.black};
`;
const RemoveButton = styled(SccTouchableOpacity).attrs({
    hitSlop: 12,
}) `
  padding: 0 4px 0 8px;
`;
